<div class="container" style="display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: center; justify-content: flex-start;">
    <!--  <div style="width: 100%; display: flex; flex-direction: row; display: flex; align-items: center; justify-content: flex-end;" id="close-container">-->
    <!--    <mat-icon svgIcon="close" (click)="close()"></mat-icon>-->
    <!--  </div>-->
      <h2 style="width: 100%;">{{ 'leadScanner.share' | translate }}</h2>

      <bee-qr-generator [qrData]="userId"></bee-qr-generator>

      <button style="width: 100%;" class="regular-18px-center-primary"
              mat-raised-button
              type="button"
              (click)="closeDialog()" >
              {{ 'leadScanner.close' | translate }}
      </button>
    </div>

